import React, { useState } from 'react';
import { dateToLocal } from '../../shared/Functions';
import { ReportsVService } from '../../../services/V2/gozer';
import { CircularProgress, Grid, Link } from '@material-ui/core';
import { getRecurringListings } from '../../shared/ExportFunctions';
import { CustomTable } from '../../shared/CustomTable';

export const RecurringReportList = ({ model }) => {
	const [refresh, setRefresh] = useState<boolean>(true);
	const [downloading, setDownloading] = useState<boolean>(false);

	const handleDownload = () => {
		getRecurringListings(model, new Date().toLocaleString(), setDownloading)
	}

	return (
		<div>
			<Grid container style={{ display: "flex", justifyContent: "flex-end", margin: "30px 0px 20px 0px", padding: "0px", fontSize: "14px" }}>
				<Grid item xs={1}>
					{downloading && <CircularProgress size={'1em'} style={{ marginRight: "5px" }} />}
					<b>Download</b>&nbsp;:&nbsp;<Link onClick={handleDownload} className="clickable">csv</Link>
				</Grid>
			</Grid>
			<CustomTable
				columns={[
					{ title: 'District Name', field: 'districtName', render: rowData => rowData.districtName || '-' },
					{ title: 'Account Number', field: 'accountNumber', render: rowData => rowData.accountNumber || '-' },
					{ title: 'Account Name', field: 'accountName', render: rowData => rowData.accountName || '-' },
					{ title: 'Service Address', field: 'serviceAddress', render: rowData => rowData.serviceAddress || '-' },
					{ title: 'Signup Date', field: 'signupDate', render: rowData => dateToLocal(rowData.signupDate).toLocaleString() || '-' },
					{ title: 'Method', field: 'method', render: rowData => rowData.method || '-' },
					{ title: 'Account Type', field: 'accountType', render: rowData => rowData.accountType || '-' },
					{ title: 'Last 4', field: 'last4', render: rowData => rowData.last4 || '-' },
					{ title: 'Expiration Date', field: 'expirationDate', render: rowData => rowData.expirationDate || '-' },
				]}
				pageSize={15}
				enablePaging={false}
				actions={[]}
				hiddenColumns={[]}
				setHiddenColumns={null}
				hiddenColumnsDisabled={true}
				refresh={refresh}
				setRefresh={setRefresh}
				dataEndpoint={(query) => {
					return new Promise((resolve, reject) => {
						const sendModel = { ...model };
						ReportsVService.reportsVGetRecurringSignup(query.pageNumber - 1, sendModel)
							.then(x => {
								resolve(x)
							})
							.catch(x => {
								reject(x)
							})
					})
				}}
				dataSet={null}
				title={""}
				districtId={null}
				addedQuery={null}
				tableHeight={"420px"}
				enableSearch={false}
				searchPlaceholder={null} />
		</div>
	);
};